import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-ezyagric-users',
  templateUrl: './ezyagric-users.component.html',
  styleUrls: ['./ezyagric-users.component.scss'],
})
export class EzyagricUsersComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
